import React from "react";
import { VIOLATION_CONFIG, getSeverityColor } from "../config/violationConfig";

const ViolationBadge = ({ rule, detail }) => {
  const config = VIOLATION_CONFIG[rule] ?? { label: rule, severity: "error" };
  const color  = getSeverityColor(config.severity);

  return (
    <div
      style={{
        borderLeft: `3px solid ${color}`,
        backgroundColor: `${color}18`,
        padding: "6px 10px",
        marginBottom: 6,
        borderRadius: 4,
      }}
    >
      <div style={{ color, fontWeight: 600, fontSize: 13 }}>{config.label}</div>
      {detail && <div style={{ color: "#555", fontSize: 12, marginTop: 2 }}>{detail}</div>}
    </div>
  );
};

export default ViolationBadge;
